module.exports = __webpack_public_path__ + "static/media/copy.0120d4cf.svg";